import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import { notification } from "antd";
import returnDataAccess from "src/dataAccess/returns/returnDataAccess";

export const getReturnListSuccess = createAction<any>(
    "[Return] Get Return List Success"
);
export const LoadingData = createAction<boolean>("[Return] Loading data");
export const loadingList = createAction<boolean>("[Return] Loading list");

export const getReturnListAsync = createAsyncThunk<any, IListType>(
    "[Return] Get return List",
    async (parameter, thunkAPI) => {
        thunkAPI.dispatch(loadingList(true));

        const result = await returnDataAccess
            .returnList(parameter)
            .then((res) => {
                thunkAPI.dispatch(getReturnListSuccess(res));
                thunkAPI.dispatch(loadingList(false));
                return res;
            });
        return result;
    }
);

export const saveReturnListSuccess = createAction<any>(
  "[Return] Save Return Success"
);



export const deleteReturnAsync = createAsyncThunk<any, number | number[]>(
    "[Return] Delete Return(s)",
    async (returnIdOrIds, thunkAPI) => {
        const idsToDelete: number[] = Array.isArray(returnIdOrIds)
            ? returnIdOrIds
            : [returnIdOrIds];


        await returnDataAccess.deleteReturnInfo(idsToDelete);

        const count = idsToDelete.length;
        const message = `${count} return${count === 1 ? "" : "s"} deleted successfully`;

        notification.success({ message });
        thunkAPI.dispatch(deleteReturnSuccess(idsToDelete));
        return idsToDelete;
    }
);

export const deleteReturnSuccess = createAction<number[]>(
    "[Return] Delete Return Success"
);
